var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plugin-home-tabs-text-item"},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('plugin-home-common-arrow-link',{attrs:{"text":_vm.buttonText,"url":_vm.buttonUrl,"theme":"primary"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }